import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { ModalCancelarComponent } from 'src/app/shared/components/modal-cancelar/modal-cancelar-component';
import { CoordenacaoFormComponent } from 'src/app/pages/coordenacao-form/coordenacao-form.component';

@Injectable()
export class CoordenacaoGuard implements CanDeactivate<CoordenacaoFormComponent> {
  canDeactivate(component: CoordenacaoFormComponent): Observable<boolean> | boolean {
    if (component.novoRegistro) {
      if (component.submit) { return true; }
      return component.matDialog.open(ModalCancelarComponent).afterClosed();
    } else { return true; }
  }
}
